import React from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import moment from 'moment';

export default function ComponentTaskInfo(props) {

    const getTitle = (status) => {
        switch (status) {
            case 'active':
                return "Job in queue";
            case 'prog':
                return "Job running";
            case 'done':
                return "Job successful";
            case 'error':
                return "Job result in error";
        }
    }

    return (
        <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
            <div className='bg-white w-[600px] min-h-screen absolute right-0 p-[20px]'>
                <ScrollArea>
                    <div className='px-2'>
                        <div className='flex items-center justify-between text-2xl'>
                            <h1 className='font-sans font-medium text-gray-900 uppercase'>TASK #{props.record.taskId}</h1>
                            <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => { props.onClose(); }}>
                                <span><i className="las la-times text-xl cursor-pointer"></i></span>
                            </div>
                        </div>
                        <div className='mt-2'>
                            Timestamp: <b>{moment(props.record.createdAt).format('DD MMM, yyyy hh:mm:ss A')}</b>
                        </div>
                        <hr className='my-2' />
                        <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                            <span className='flex items-center'>
                                <i className="las la-file-invoice mr-2 text-xl"></i>Outlet Summery
                            </span>
                        </div>
                        <div className='mt-4 flex items-center'>
                            <p className='text-sm font-bold text-gray-950'>Particulars</p>
                        </div>
                        <hr className='my-2' />
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Organization Info</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>#{props.record.org}</p>
                        </div>
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Outlet ID</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>#{props.record.outlet}</p>
                        </div>
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Outlet Name</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>{props.record.outletName}</p>
                        </div>
                        <hr className='my-2' />
                        <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                            <span className='flex items-center'>
                                <i className="las la-file-invoice mr-2 text-xl"></i>Job Summery
                            </span>
                        </div>
                        <hr className='my-2' />
                        <div className='flex items-center'>
                            <p className='text-sm font-medium text-gray-950'>Job Status</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>{getTitle(props.record.status)}</p>
                        </div>
                        <div className=''>
                            <p className='text-sm font-medium text-gray-950'>Job Log</p>
                            <p className='text-xs font-medium'>{props.record.log}</p>
                        </div>
                        <hr className='my-2' />
                    </div>
                </ScrollArea >
            </div >
        </div >
    )
}
